define('lq/events/actions/officeAddinLoginCommand',[
    'underscore',
    'lq',
    'lq/events/actions/eventAction'
], function (_, lq, EventAction) {
    'use strict';

    // reference: https://dev.office.com/reference/add-ins/outlook/1.5/Office

    var initialized = false;
    var afterInitialization = [];

    function OfficeAddinLoginCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(OfficeAddinLoginCommand, EventAction);

    OfficeAddinLoginCommand.typeName = 'OfficeAddinLoginCommand';

    // unable to batch for now, because requesting a token is async
    OfficeAddinLoginCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    OfficeAddinLoginCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (initialized)
            this.startReadingMessage(continuation);
        else {
            afterInitialization.push(this.startLogin.bind(this, continuation));

            require([
                'https://appsforoffice.microsoft.com/lib/1/hosted/Office.js'
            ], function () {
                Office.initialize = function () {
                    initialized = true;

                    _.each(afterInitialization,
                        function (afterInitialization) {
                            afterInitialization();
                        });
                };
            });
        }
    };

    var loginCallback = function (self, result, returnUrl, continuation) {
        if (result.status === 'Success') {
            returnUrl = returnUrl || lq.getTenantUrl('');

            if (self.eventIsEnabled('userLoggedIn'))
                self.piping.dispatcher.refreshCsrfToken(function () {
                    self.triggerEvent('userLoggedIn', continuation, returnUrl);
                });
            else
                window.location = returnUrl;
        }
        else {
            if (result.status === 'InvalidCredentials' || result.status === 'UserNotFound')
                self.handleError('invalidCredentials', 'The username or password provided is incorrect.', continuation);
            else if (result.status === 'AccountLocked')
                self.handleError('accountLocked', 'Your account has been locked out because of too many invalid login attempts.', continuation);
            else
                alert('Unable to login.');
        }
    };

    OfficeAddinLoginCommand.prototype.startLogin = function (continuation) {
        var self = this;
        
        var returnUrl = this.piping.queryString.getValueOf('ReturnUrl');

        Office.context.mailbox.getCallbackTokenAsync(function (callbackToken) {
            if (callbackToken.status !== 'succeeded')
                throw new Error('Unable to get a token from Outlook.');

            self.piping.dispatcher.dispatch('Outlook/LogIn',
                {
                    actionId: self.piping.actionId,
                    commandId: self.eventData.commandId,
                    ewsUrl: Office.context.mailbox.ewsUrl,
                    callbackToken: callbackToken.value,
                    itemId: Office.context.mailbox.item.itemId
                })
                .then(function (result) {
                    loginCallback(self, result, returnUrl, continuation);
                });
        });

        OfficeAddinLoginCommand.prototype.handleError = function (eventName, defaultMessage, continuation) {
            if (this.eventIsEnabled(eventName)) {
                this.triggerEvent(eventName, continuation);
            } else {
                alert(defaultMessage);
                continuation();
            }
        };
    };

    return OfficeAddinLoginCommand;
});
